import {ISSUE_FILTER_PROPERTIES, ISSUE_HIDDEN_FILTER_PROPERTIES} from '../constants/issue-query-params';
import {formatLocalDateTimeRange, formatUtcDateRange} from './date-helpers';
import {getToken} from './getToken';
import {getSortValue} from './jsonapi-helpers';
import {toV1, toV1Structure} from './version-converters';

export const buildGetParams = ({targetUrn, documentVersion, limit, offset, queryParams = {}} = {}) => {
  const getQueryParam = param => (param.constructor === Array ? param.join(',') : param);
  const query = {
    'page[limit]': limit || 10,
    'page[offset]': offset || 0
  };
  const customAttributesQueryParams = queryParams[ISSUE_FILTER_PROPERTIES.SELECTED_CUSTOM_ATTRIBUTES_VALUES]
    ? JSON.parse(queryParams[ISSUE_FILTER_PROPERTIES.SELECTED_CUSTOM_ATTRIBUTES_VALUES])
    : [];

  if (targetUrn) {
    query['filter[target_urn]'] = `${targetUrn}${documentVersion ? `@${documentVersion}` : ''}`;
  }
  const {sort, csvVersion, format} = queryParams;
  let sortValue = null;
  if (sort) {
    sortValue = getSortValue(sort, {}, toV1);
    query['sort'] = sortValue;
  }
  if (queryParams[ISSUE_HIDDEN_FILTER_PROPERTIES.ID] && queryParams[ISSUE_HIDDEN_FILTER_PROPERTIES.ID].length > 0) {
    query['filter[id]'] = getQueryParam(queryParams[ISSUE_HIDDEN_FILTER_PROPERTIES.ID]);
  }
  if (
    queryParams[ISSUE_FILTER_PROPERTIES.STATUS_FILTER] &&
    queryParams[ISSUE_FILTER_PROPERTIES.STATUS_FILTER].length > 0
  ) {
    query['filter[status]'] = getQueryParam(queryParams[ISSUE_FILTER_PROPERTIES.STATUS_FILTER]);
  }
  if (
    queryParams[ISSUE_FILTER_PROPERTIES.ISSUE_TYPE_FILTER] &&
    queryParams[ISSUE_FILTER_PROPERTIES.ISSUE_TYPE_FILTER].length > 0
  ) {
    query['filter[ng_issue_type_id]'] = getQueryParam(queryParams[ISSUE_FILTER_PROPERTIES.ISSUE_TYPE_FILTER]);
  }
  if (
    queryParams[ISSUE_FILTER_PROPERTIES.ISSUE_SUB_TYPE_FILTER] &&
    queryParams[ISSUE_FILTER_PROPERTIES.ISSUE_SUB_TYPE_FILTER].length > 0
  ) {
    query['filter[ng_issue_subtype_id]'] = getQueryParam(queryParams[ISSUE_FILTER_PROPERTIES.ISSUE_SUB_TYPE_FILTER]);
  }
  if (
    queryParams[ISSUE_FILTER_PROPERTIES.CREATED_BY_FILTER] &&
    queryParams[ISSUE_FILTER_PROPERTIES.CREATED_BY_FILTER].length > 0
  ) {
    query['filter[created_by]'] = getQueryParam(queryParams[ISSUE_FILTER_PROPERTIES.CREATED_BY_FILTER]);
  }
  if (
    queryParams[ISSUE_FILTER_PROPERTIES.ASSIGNED_TO_FILTER] &&
    queryParams[ISSUE_FILTER_PROPERTIES.ASSIGNED_TO_FILTER].length > 0
  ) {
    query['filter[assigned_to]'] = getQueryParam(queryParams[ISSUE_FILTER_PROPERTIES.ASSIGNED_TO_FILTER]);
  }
  if (
    queryParams[ISSUE_FILTER_PROPERTIES.OWNER_FILTER] &&
    queryParams[ISSUE_FILTER_PROPERTIES.OWNER_FILTER].length > 0
  ) {
    query['filter[owner]'] = getQueryParam(queryParams[ISSUE_FILTER_PROPERTIES.OWNER_FILTER]);
  }
  if (
    queryParams[ISSUE_FILTER_PROPERTIES.CREATED_AT_START_FILTER] ||
    queryParams[ISSUE_FILTER_PROPERTIES.CREATED_AT_END_FILTER]
  ) {
    query['filter[created_at]'] = formatLocalDateTimeRange(
      queryParams[ISSUE_FILTER_PROPERTIES.CREATED_AT_START_FILTER],
      queryParams[ISSUE_FILTER_PROPERTIES.CREATED_AT_END_FILTER]
    );
  }
  if (
    queryParams[ISSUE_FILTER_PROPERTIES.DUE_DATE_START_FILTER] ||
    queryParams[ISSUE_FILTER_PROPERTIES.DUE_DATE_END_FILTER]
  ) {
    query['filter[due_date]'] = formatUtcDateRange(
      queryParams[ISSUE_FILTER_PROPERTIES.DUE_DATE_START_FILTER],
      queryParams[ISSUE_FILTER_PROPERTIES.DUE_DATE_END_FILTER],
      {isIso: false}
    );
  }
  if (
    queryParams[ISSUE_FILTER_PROPERTIES.ROOT_CAUSE_ID_FILTER] &&
    queryParams[ISSUE_FILTER_PROPERTIES.ROOT_CAUSE_ID_FILTER].length > 0
  ) {
    query['filter[root_cause_id]'] = getQueryParam(queryParams[ISSUE_FILTER_PROPERTIES.ROOT_CAUSE_ID_FILTER]);
  }
  if (queryParams[ISSUE_FILTER_PROPERTIES.LBS_LOCATION_FILTER]) {
    if (queryParams[ISSUE_FILTER_PROPERTIES.INCLUDE_SUBLOCATIONS]) {
      query['filter[lbs_sublocations]'] = queryParams[ISSUE_FILTER_PROPERTIES.LBS_LOCATION_FILTER];
    } else {
      query['filter[lbs_location]'] = queryParams[ISSUE_FILTER_PROPERTIES.LBS_LOCATION_FILTER];
    }
  }
  if (queryParams[ISSUE_FILTER_PROPERTIES.SEARCH]) {
    query['filter[title]'] = queryParams[ISSUE_FILTER_PROPERTIES.SEARCH];
  }
  if (customAttributesQueryParams.length) {
    customAttributesQueryParams.forEach(({id, value}) => {
      query[`filter[custom_attributes][${id}]`] = typeof value === 'object' ? value.id : value;
    });
  }
  if (csvVersion && format) {
    query['csv_version'] = csvVersion;
    query['format'] = format;
    query['sort'] = sortValue;
  }

  return query;
};

export const mapRequestToV1Structure = (values, type, isIssue, id) => {
  const attributes = toV1Structure(values, {isIssue});
  delete attributes.id;
  return {
    data: {
      id,
      type,
      attributes
    }
  };
};

export const addAuthTokenV1 = (config, getState, dispatch) =>
  getToken({getState, dispatch}).then(token => {
    config.headers || (config.headers = {});
    config.headers.Accept = 'application/vnd.api+json';
    config.headers['Content-Type'] = 'application/vnd.api+json';
    config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  });
